function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Social Media / Small / Dark / Instagram");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-",
  transform: "translate(-11996.000000, -725.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Social-Media-Copy",
  transform: "translate(11894.000000, 725.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Social-Media-/-Small-/-Dark-/-Instagram",
  transform: "translate(102.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.3601667,8.756 L11.5511,8.756 C9.98543333,8.756 8.71163333,10.0298 8.71163333,11.5954667 L8.71163333,21.4045333 C8.71163333,22.9702 9.98543333,24.2443667 11.5511,24.2443667 L21.3601667,24.2443667 C22.9258333,24.2443667 24.2,22.9705667 24.2,21.4045333 L24.2,11.5954667 C24.2,10.0298 22.9262,8.756 21.3601667,8.756 Z M16.4556333,21.5988667 C13.6444,21.5988667 11.3571333,19.3116 11.3571333,16.5 C11.3571333,13.6887667 13.6444,11.4015 16.4556333,11.4015 C19.2672333,11.4015 21.5545,13.6887667 21.5545,16.5 C21.5545,19.3112333 19.2668667,21.5988667 16.4556333,21.5988667 Z M21.7184,12.4556667 C21.0529,12.4556667 20.5117,11.9144667 20.5117,11.2493333 C20.5117,10.5842 21.0529,10.043 21.7184,10.043 C22.3835333,10.043 22.9247333,10.5842 22.9247333,11.2493333 C22.9247333,11.9144667 22.3835333,12.4556667 21.7184,12.4556667 Z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.4556333,13.5560333 C14.8327667,13.5560333 13.5113,14.8767667 13.5113,16.4996333 C13.5113,18.1232333 14.8327667,19.4443333 16.4556333,19.4443333 C18.0792333,19.4443333 19.3996,18.1232333 19.3996,16.4996333 C19.3996,14.8771333 18.0788667,13.5560333 16.4556333,13.5560333 Z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.4556333,0 C7.3678,0 0,7.3678 0,16.4556333 C0,25.5434667 7.3678,32.9112667 16.4556333,32.9112667 C25.5434667,32.9112667 32.9112667,25.5434667 32.9112667,16.4556333 C32.9112667,7.3678 25.5434667,0 16.4556333,0 Z M26.3541667,21.4045333 C26.3541667,24.1585667 24.1142,26.3985333 21.3601667,26.3985333 L11.5511,26.3985333 C8.79743333,26.3985333 6.5571,24.1585667 6.5571,21.4045333 L6.5571,11.5954667 C6.5571,8.8418 8.79743333,6.60146667 11.5511,6.60146667 L21.3601667,6.60146667 C24.1142,6.60146667 26.3541667,8.8418 26.3541667,11.5954667 L26.3541667,21.4045333 Z",
  fillRule: "nonzero"
}))))));

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Instagram.07f32da8.svg";
export { ForwardRef as ReactComponent };